module.exports = __webpack_public_path__ + "static/img/easily-track-all-assignments.efd2794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/easily-track-all-assignments.png
// module id = JCZu
// module chunks = 0